const MAX_EVENTS = 200

const qaWindow = () =>
    /** @type {any} */ (
        typeof window !== 'undefined'
            ? window
            : typeof globalThis !== 'undefined'
            ? globalThis
            : null
    )

function emptyStore() {
    return {
        startedAt: Date.now(),
        counters: {},
        gauges: {},
        gaugePeaks: {},
        events: [],
    }
}

function cloneStore(store) {
    return {
        startedAt: store.startedAt,
        capturedAt: Date.now(),
        counters: { ...store.counters },
        gauges: { ...store.gauges },
        gaugePeaks: { ...store.gaugePeaks },
        events: store.events.map(event => ({ ...event })),
    }
}

function installQaApi(w) {
    if (typeof w.__getKnovMediaDockDiagnostics !== 'function') {
        w.__getKnovMediaDockDiagnostics = () => cloneStore(resolveStore(w))
    }
    if (typeof w.__resetKnovMediaDockDiagnostics !== 'function') {
        w.__resetKnovMediaDockDiagnostics = () => {
            const previousGauges = resolveStore(w).gauges
            w.__KNOV_QA_MEDIA_DOCK_DIAGNOSTICS__ = {
                ...emptyStore(),
                gauges: { ...previousGauges },
                gaugePeaks: { ...previousGauges },
            }
            return cloneStore(w.__KNOV_QA_MEDIA_DOCK_DIAGNOSTICS__)
        }
    }
}

function resolveStore(w) {
    const store = (w.__KNOV_QA_MEDIA_DOCK_DIAGNOSTICS__ ||= emptyStore())
    installQaApi(w)
    return store
}

export function mediaDockQaDiagnosticsEnabled() {
    try {
        return Boolean(qaWindow()?.__KNOV_QA_MEDIA_DOCK_PROBE__)
    } catch {
        return false
    }
}

export function incrementMediaDockQaCounter(name, amount = 1) {
    if (!mediaDockQaDiagnosticsEnabled()) return
    const store = resolveStore(qaWindow())
    store.counters[name] = (store.counters[name] || 0) + amount
}

export function setMediaDockQaGauge(name, value) {
    if (!mediaDockQaDiagnosticsEnabled()) return
    const store = resolveStore(qaWindow())
    store.gauges[name] = value
    store.gaugePeaks[name] = Math.max(store.gaugePeaks[name] ?? value, value)
}

export function recordMediaDockQaEvent(name, detail = {}) {
    if (!mediaDockQaDiagnosticsEnabled()) return
    const store = resolveStore(qaWindow())
    store.events.push({ name, at: Date.now(), ...detail })
    if (store.events.length > MAX_EVENTS) {
        store.events.splice(0, store.events.length - MAX_EVENTS)
    }
}

export function getMediaDockQaUtf8ByteLength(value) {
    const serialized = String(value)
    if (typeof TextEncoder !== 'undefined') {
        return new TextEncoder().encode(serialized).byteLength
    }
    if (typeof Blob !== 'undefined') {
        return new Blob([serialized]).size
    }
    return serialized.length
}

export function resetMediaDockQaDiagnosticsForTests() {
    const w = qaWindow()
    if (!w) return
    w.__KNOV_QA_MEDIA_DOCK_DIAGNOSTICS__ = emptyStore()
    installQaApi(w)
}
